var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.396,
    height: 20.689,
    viewBox: "0 0 19.396 20.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M19.09.1A.647.647,0,0,1,19.4.646v19.4a.647.647,0,0,1-.647.647H14.87a.647.647,0,0,1-.647-.647V18.1H12.931v1.94a.647.647,0,0,1-.647.647H.647A.647.647,0,0,1,0,20.042V12.931a.647.647,0,0,1,.443-.613L7.758,9.879V5.819a.647.647,0,0,1,.357-.578L18.46.068A.647.647,0,0,1,19.09.1ZM7.758,11.242,1.293,13.4v6H7.758ZM9.051,19.4h2.586v-1.94a.647.647,0,0,1,.647-.647H14.87a.647.647,0,0,1,.647.647V19.4H18.1V1.692L9.051,6.218Z",
    transform: "translate(0 0)",
    fill: "#888",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M4.5,17.095H5.793v1.293H4.5Zm2.586,0H8.379v1.293H7.086ZM4.5,19.681H5.793v1.293H4.5Zm2.586,0H8.379v1.293H7.086Zm5.172-5.172h1.293V15.8H12.258Zm2.586,0h1.293V15.8H14.845Zm-2.586,2.586h1.293v1.293H12.258Zm2.586,0h1.293v1.293H14.845Zm2.586-2.586h1.293V15.8H17.431Zm0,2.586h1.293v1.293H17.431Zm-5.172-5.172h1.293v1.293H12.258Zm2.586,0h1.293v1.293H14.845Zm2.586,0h1.293v1.293H17.431ZM12.258,9.336h1.293v1.293H12.258Zm2.586,0h1.293v1.293H14.845Zm2.586,0h1.293v1.293H17.431Zm0-2.586h1.293V8.043H17.431Z",
    transform: "translate(-1.914 -2.871)",
    fill: "#888"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.a27c7f1f13e472ecbe4d957bcd2cf689.svg";
export { ForwardRef as ReactComponent };